import React from 'react';
import PropTypes from 'prop-types';
import data from '../lang/arsskyrsla-data.json';
import { Grid, GridItem, useBreakpointValue } from '@chakra-ui/react';
import Navbar from '../components/navBar/NavBar';
import BasePage from './BasePage';
import { getComponentByType } from '../DynamicComponent';

function ArsskyrslaPage({ type, version }) {
  ArsskyrslaPage.propTypes = {
    type: PropTypes.string.isRequired,
    version: PropTypes.string,
  };

  const currentVersion = version ? version : data.versions[0].version;
  const pageVersion = data.versions.find(
    version => version.version === currentVersion
  );
  const menuItems = pageVersion.topMenu.menuItems;
  const isMobile = useBreakpointValue({ base: true, md: false });
  const dataPage = pageVersion.pages.find(page => page.page === type);
  const orderedComponents = dataPage.components.sort(
    (a, b) => a.order - b.order
  );

  return (
    <React.Fragment>
      <Navbar menuItems={menuItems} onHomepage={false} />
      <Grid
        templateColumns={`repeat(${isMobile ? 4 : 12}, 1fr)`}
        columnGap={isMobile ? '24px' : '32px'}
        rowGap={isMobile ? '0px' : '20px'}
        pl={isMobile ? '16px' : '48px'}
        pr={isMobile ? '16px' : '48px'}
        marginBottom={orderedComponents.length < 1 ? '48px' : '0px'}
      >
        <GridItem colStart={isMobile ? 1 : 2} colEnd={isMobile ? 5 : 7}>
          <BasePage type={type} />
        </GridItem>
        <GridItem colStart={isMobile ? 1 : 2} colEnd={isMobile ? 5 : 12}>
          {orderedComponents.map((component, index) =>
            getComponentByType(component.type, component.content, index)
          )}
        </GridItem>
      </Grid>
    </React.Fragment>
  );
}

export default ArsskyrslaPage;
